import { BestsellerEventsResponseEventDto } from 'api/common.generated';
import { BETRADAR_DEVICE_TYPES, BETRADAR_STREAM_TYPES } from 'shared/constants/common';
import { RequestsInstance } from './index';

interface MarketingPrematchResponse {
	isError: boolean;
	code: number;
	events: BestsellerEventsResponseEventDto[];
}

const IntegrationApiWrapper = (requests: RequestsInstance) => {
	return {
		getCardGames: () => {
			return requests.get(`integrations/tvbet`);
		},
		getStatsScore: (id: number) => {
			return requests.get(`integrations/statscore/${id}`);
		},
		getStatsScoreId: () => {
			return requests.get(`integrations/statscore`);
		},
		getBetradarLiveStream: (streamId: string, streamType: BETRADAR_STREAM_TYPES, device: BETRADAR_DEVICE_TYPES) => {
			return requests.get(`integrations/betradar-live-stream/${streamId}/${streamType}/${device}`);
		},
		getSisLiveStream: (eventId: number, sportId: number) => {
			return requests.get(`integrations/sis-live-stream/event-id/${eventId}/sport-id/${sportId}`);
		},
		getMarketingPrematch: (eventIds: number[]) => {
			const idsParam = eventIds.join(',');
			return requests.getRaw<MarketingPrematchResponse>(`/integrations/sportbetfan/prematch/${idsParam}`, {
				headers: {
					'Content-Type': 'application/json',
				},
			});
		},
	};
};

export default IntegrationApiWrapper;
